import {I18n} from 'aws-amplify/utils';

import {
    DeleteRecordsConfirmationButton,
    ReloadButton,
    SimplePageHeader,
} from '@flexinet/ui-components';

import {
    Box,
    Button,
} from '@mantine/core';

import {useNavigate} from 'react-router-dom';
import {AiOutlinePlus} from 'react-icons/ai'
import {usePersonasSelection} from "../hooks/usePersonasSelection.ts";
import {usePersonas} from "../hooks/usePersonas.ts";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {GeneratePersonaButton} from '../../test-data/buttons/GeneratePersonaButton.tsx';
import {FilterRecordsButton} from '../buttons/FilterRecordsButton.tsx';
import {config} from "../config";
import {PersonaStatus} from '../types';

const ComponentsReloadButton = () => {

    const {refetchRecords} = usePersonas();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => refetchRecords()}/>
        </Box>
    );
};

const AddRecordButton = ({
                             buttonText = 'Add Persona',
                             size = 'sm',
                             onClick,
                         }: {
    buttonText?: string,
    size?: string,
    onClick?: () => void
}) => {
    const navigate = useNavigate();

    if (typeof onClick === 'undefined') {
        onClick = () => {
            navigate('add');
        };
    }

    return (
        <Button
            variant={"filled"}
            disabled={false}
            leftSection={<AiOutlinePlus/>}
            onClick={onClick}
            size={size}
        >
            {I18n.get(buttonText)}
        </Button>
    );
};

const DeleteRecordButton = () => {

    const {deleteRecords} = usePersonas();

    const {
        selection,
        handleClearSelection,
    } = usePersonasSelection();

    const recordIds = Object.keys(selection);
    let disabled = true;
    if (recordIds.length > 0) {
        disabled = false;
    }

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={() => {
            deleteRecords()
            handleClearSelection()
        }}/>);
};


interface IndexPageHeaderProps {
    onFilterChange: (status: PersonaStatus | null) => void;
}

const useTools = (onFilterChange: (status: PersonaStatus | null) => void) => {

    const {allowedActions} = useVerifiedPermissions()

    const tools = [
        <FilterRecordsButton key='filter' onFilterChange={onFilterChange} defaultStatus={PersonaStatus.ENABLED}/>,
        <ComponentsReloadButton key='reload'/>,
        <GeneratePersonaButton key='generate'/>
    ];

    if (allowedActions.includes('DeletePersona')) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes('CreatePersona')) {
        tools.push(<AddRecordButton key='add'/>);
    }

    return tools;
};

export const IndexPageHeader = ({onFilterChange}: IndexPageHeaderProps) => {
    return (
        <SimplePageHeader
            title={I18n.get(config.titles.plural)}
            tools={useTools(onFilterChange)}
        />
    );
};
